import { render, staticRenderFns } from "./RelatoriosExpurgoLogs.vue?vue&type=template&id=30788bf2&scoped=true&"
import script from "./RelatoriosExpurgoLogs.vue?vue&type=script&lang=js&"
export * from "./RelatoriosExpurgoLogs.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosExpurgoLogs.vue?vue&type=style&index=0&id=30788bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30788bf2",
  null
  
)

export default component.exports